import styled from 'styled-components';

export default styled.div`
	background: rgba(0, 0, 0, 0.2);
	position: fixed;
	top: var(--px-55);
	bottom: 0;
	right: 0;
	left: 0;
	z-index: 999;
	.ares-error {
		position: absolute;
		z-index: 1;
	}

	.toast-message-container {
		position: absolute;
		z-index: 4;
		left: var(--px-30);
	}
`;
